import { render, staticRenderFns } from "./Pasajeros.vue?vue&type=template&id=03dbf778"
import script from "./Pasajeros.vue?vue&type=script&lang=js"
export * from "./Pasajeros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports